import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { AppMaterialModule } from './app-material.module'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { AuthHttpInterceptor } from './auth/auth-http-interceptor'
import { AuthService } from './auth/auth.service'
import {
  NavigationMenuComponent,
} from './common/navigation-menu/navigation-menu.component'
import { PageNotFoundComponent } from './common/page-not-found/page-not-found.component'
import { SimpleDialogComponent } from './common/simple-dialog/simple-dialog.component'
import { LoginComponent } from './login/login.component'
import { LoaderService } from './services/loader.service'
import { UiService } from './services/ui.service'

@NgModule({
  declarations: [
    LoginComponent,
    AppComponent,
    PageNotFoundComponent,
    SimpleDialogComponent,
    NavigationMenuComponent,
  ],
  exports: [NavigationMenuComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AppMaterialModule,
    HttpClientModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    LoaderService,
    AuthService,
    UiService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
